import {Box, Fade, Modal, Typography} from "@mui/material";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { deletePurchaseRequest } from "../../store/slices/purchaseRequestSlice";
import { successToast } from "../../response/successToast";

const PurchaseRequestDeleteModal = ({purchaseRequestDelete, setPurchaseRequestDelete,requestId,setRequestId,fetchData}) => {
  const dispatch = useDispatch()
  const [loader, setLoader] = useState(false)

  const purchaseRequestDeleteModalClose = () =>{
    setPurchaseRequestDelete(!purchaseRequestDelete)
    setRequestId('')
  }

  const onDeletePurchaseRequest = async () => {
    
    try {
      setLoader(true);
      const response = await dispatch(deletePurchaseRequest(requestId));
      if (response?.success) {
        setRequestId('')
        successToast(response?.message || "Purchase Request Deleted Successfully")
        setPurchaseRequestDelete(!purchaseRequestDelete)
        fetchData();
      } else {
        console.error("Failed! Something went wrong.");
        setPurchaseRequestDelete(!purchaseRequestDelete)
        setRequestId('')
      }
    } catch (error) {
      console.error("API call error:", error);
    } finally {
      setLoader(false);
    }
  };
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={purchaseRequestDelete}
        onClose={purchaseRequestDeleteModalClose}
        closeAfterTransition
      >
        <Fade in={purchaseRequestDelete}>
          <Box className="modal-wrapper modal-ui">
            <Box className="modal-body">
              <Box variant="div" component="div" className="title">
                <Typography variant="h3" component="h3">
                Do you want to delete this purchase ticket?
                </Typography>
                <Typography variant="body1" component="p">
                    This action can’t be undone.
                </Typography>
              </Box>
              <Box variant="div" component="div" className="body"></Box>
              <Box variant="div" component="div" className="footer">
                <Box variant="div" component="div" className="btn-group">
                  <Button
                    variant="contained"
                    size="large"
                    className="primary-btn btn"
                    disableRipple
                    onClick={() => {onDeletePurchaseRequest()}}
                    disabled={loader}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    className="secondary-btn btn"
                    disableRipple
                    onClick={() => setPurchaseRequestDelete(false)}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default PurchaseRequestDeleteModal;
